import React from 'react';
import {Button, Card} from 'antd';
import ClubMondaySelect from './StudentClubForm/ClubMondaySelect';
import ClubTuesdaySelect from './StudentClubForm/ClubTuesdaySelect';
import ClubWednesdaySelect from './StudentClubForm/ClubWednesdaySelect';
import ClubThursdaySelect from './StudentClubForm/ClubThursdaySelect';
import ClubFriDaySelect from './StudentClubForm/ClubFridaySelect';
import {required} from "../validDesc";
import {TextField} from "redux-form-antd";
import {Field} from "redux-form/immutable";


const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 4},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 20},
    },
};
const StudContact = props => {
    const { changStudContact } = props;
    return (
        <Card title="緊急聯絡人資訊">
            <Button onClick={() => changStudContact('moth')} size='large'
                    style={{width: '50%', marginBottom: '10px'}}>
                載入母親資料
            </Button>

            <Button onClick={() => changStudContact('fath')} size='large'
                    style={{width: '50%', marginBottom: '10px'}}>
                載入父親資料
            </Button>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="緊急聯絡人姓名"
                   name="contact_name" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="關係"
                   name="contact_relationship" type="text"></Field>
            <Field {...formItemLayout} validate={[required]} component={TextField} label="行動電話"
                   name="contact_tel" type="text"></Field>
        </Card>
    )
}
export default StudContact



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ApplicationForAdmissionContaioner/NewStudentForm/StudContact.jsx